
// depLocation is dependency location for testing cases
export const switchENV = (envUrl, depLocation) => {
    const location = depLocation || document.location.origin;
    const production = import.meta.env.MODE === 'production';
    const staging = import.meta.env.MODE === 'staging';
    const development = import.meta.env.MODE === 'development';
    const envList = import.meta.env;
    if(!production && !import.meta.env.TEST) {
        console.log(envList)
    }
    
    if (production || staging || development) {
        switch (location) {
            case import.meta.env.VITE_DEV:
                return envUrl.dev;

            case import.meta.env.VITE_STAGE:
                return envUrl.stage;

            case import.meta.env.VITE_PROD:
                return envUrl.prod;

            default:
                return envUrl.prod;
        }
    }
    else {
        return envUrl.prod;
    }
};

export const externalLinkEnvUrl = {
    dev: 'https://wwwdev.troweprice.com',
    stage: 'https://wwwstage.troweprice.com',
    prod: 'https://www.troweprice.com'
};

export const externalEnvUrl = {
    dev: 'https://www3dev.troweprice.com',
    stage: 'https://www3qual.troweprice.com/',
    prod: 'https://www3.troweprice.com'
};

const switchEnvUrl = path => switchENV(
    externalLinkEnvUrl
) + path;

export const envApiConfig =
    import.meta.env.MODE === 'production'
        ? `${document.location.origin}/usis/advice/tools/retirement-income-calculator/api-config.json`
        : `${document.location.origin}/api-config.json`;

export const mgpSsoDevLink =
    'https://dev.moneyguidepro.com/troweprice/SsoSamlNoRef.aspx?IntegrationId=186';

export const apiEnvUrl = {
    dev: 'https://api.dev.troweprice.com',
    stage: 'https://api.confidence.troweprice.com',
    prod: 'https://api.public.troweprice.com'
};

// AEM Pages
export const aemPageLinks = {
    faqLink: switchEnvUrl('/personal-investing/planning-and-research/advice/planning-service/faq.html'),
    learnMoreLink: switchEnvUrl('/personal-investing/planning-and-research/advice/planning-service/implementation-guide.html')
}

// AEM PDFs
export const aemPdfLinks = {
    aggregationServiceTermsLink: switchEnvUrl(`/content/dam/iinvestor/products-and-services/adv/Aggregation-Services-Terms.pdf`),
    formADVLink: switchEnvUrl('/content/dam/iinvestor/advice-and-planning/planning-service/t-rowe-price-planning-service-form-adv.pdf'),
    fpsClientAgreementLink: switchEnvUrl('/content/dam/iinvestor/advice-and-planning/planning-service/t-rowe-price-planning-service-form-client-agreement.pdf'),
    advisoryServicesCrs: switchEnvUrl('/content/dam/iinvestor/Forms/trpas-form-crs.pdf'),
    investmentServicesCrs: switchEnvUrl('/content/dam/iinvestor/Forms/trpis-form-crs.pdf'),
    PrivacyNoticeUSCAN: switchEnvUrl('/content/dam/trowecorp/Pdfs/PrivacyNoticeUSCAN.pdf')
};

export const FPSClientAgreement = (showJulyReleaseText) => {
    return showJulyReleaseText ? [
        {
            id: '1',
            name: 'T. Rowe Price Planning Service Client Agreement',
            agreementLink: aemPdfLinks.fpsClientAgreementLink,
            linkId: 'fps-client-agreement-pdf'
        },
        {
            id: '2',
            name: 'T. Rowe Price Planning Service Form ADV',
            agreementLink: aemPdfLinks.formADVLink,
            linkId: 'fps-adv-form-pdf'
        },
        {
            id: '3',
            name: 'TRP Advisory Services Form CRS',
            agreementLink: aemPdfLinks.advisoryServicesCrs,
            linkId: 'advisory-services-crs-pdf'
        },
        {
            id: '4',
            name: 'TRP Investment Services Form CRS',
            agreementLink: aemPdfLinks.investmentServicesCrs,
            linkId: 'investment-services-crs-pdf'
        },
        {
            id: '5',
            name: 'T. Rowe Price Privacy Notice (U.S. & Canada)',
            agreementLink: aemPdfLinks.PrivacyNoticeUSCAN,
            linkId: 'privacy-notice-USCAN-pdf'
        }
    ] : [
            {
                id: '1',
                name: 'T. Rowe Price Planning Service Client Agreement',
                agreementLink: aemPdfLinks.fpsClientAgreementLink
            },
            {
                id: '2',
                name: 'T. Rowe Price Planning Service Form ADV',
                agreementLink: aemPdfLinks.formADVLink
            }
        ]
};

export const rasLandingPage = switchENV(externalLinkEnvUrl) + '/personal-investing/advice/retirement-advisory-service/index.html'

export const insightsPage = switchENV(externalLinkEnvUrl) + '/personal-investing/resources/insights/subscribe.html';


export const adviceProspectusBaseUrl =
    'https://prospectus-express.broadridge.com/summary.asp?doctype=pros&clientid=trowepll&fundid=';


// Session Timeout logout urls
const logOutPath = '/usis/login/logout?sdurl=';
const logoutSdurl = '/usis/my-accounts/post-logout'


// Session Timeout logout urls
export const logoutUrl = switchENV(externalLinkEnvUrl) + logOutPath + switchENV(externalLinkEnvUrl) + logoutSdurl;

// Planning Summary URL
export const investingExperienceUrl = switchENV(externalLinkEnvUrl) + '/usis/advice/planning-summary';

// RIC URLs
export const BASE_URL = '/usis/advice/tools/retirement-income-calculator';
export const SECURE_URL = `${BASE_URL}/secure`;
export const GUEST_URL = `${BASE_URL}/guest`;
export const NEXT_STEPS_URL = `${BASE_URL}/next-steps`;

export const includeQueryParams = (url) => {
  const queryParams = window.location.search;
  return url + queryParams;
}

export const baseURLs = [
    BASE_URL,
    `${BASE_URL}/`
];

export const notLandingURLs = [
    SECURE_URL,
    `${SECURE_URL}/`,
    NEXT_STEPS_URL,
    `${NEXT_STEPS_URL}/`
];

export const loggedInMGPURLs = [
    SECURE_URL,
    `${SECURE_URL}/`
];

export const nextStepsURLs = [
    NEXT_STEPS_URL,
    `${NEXT_STEPS_URL}/`
];